<template>
  <div class="rag-dot-container">
    <span
      v-if="showDot"
      class="rag-dot"
      :class="ragStatus"
      role="img"
      :aria-label="`RAG status: ${ragStatus}`"
    >
      {{ ragStatusLetter }}
    </span>
    <slot name="label">{{ formattedMetric }}</slot>
  </div>
</template>

<style scoped>
.rag-dot-container {
  display: inline-flex;
  align-items: center;
  gap: 0.5em;
}

.rag-dot {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.rag-dot.red {
  background-color: var(--kate-danger);
  color: var(--kate-type-white);
}

.rag-dot.amber {
  background-color: var(--kate-warning);
  color: var(--kate-type-dark);
}

.rag-dot.green {
  background-color: var(--kate-success);
  color: var(--kate-type-dark);
}
</style>

<script>
import format from 'number-format.js';

const VALID_RAG_STATUSES = ['red', 'amber', 'green'];
const VALID_METRIC_TYPES = ['percentage', 'number', 'string'];
const RAG_STATUS_LETTER_MAP = {
  red: 'R',
  amber: 'A',
  green: 'G',
};
const EMPTY = '-';

export default {
  props: {
    metricValue: {
      type: [String, Number],
      default: '',
    },
    ragStatus: {
      type: String,
      validator: value => !value || VALID_RAG_STATUSES.includes(value),
    },
    metricType: {
      type: String,
      validator: value => !value || VALID_METRIC_TYPES.includes(value),
    },
  },
  computed: {
    hasValidMetric() {
      return this.metricValue !== EMPTY
        && this.metricValue != null
        && this.metricValue !== '';
    },

    isValidRagStatus() {
      return !!(this.ragStatus && VALID_RAG_STATUSES.includes(this.ragStatus));
    },

    showDot() {
      return this.hasValidMetric && this.isValidRagStatus;
    },

    ragStatusLetter() {
      return RAG_STATUS_LETTER_MAP[this.ragStatus] || '';
    },

    formattedMetric() {
      if (!this.hasValidMetric) {
        return EMPTY;
      }
      switch (this.metricType) {
        case 'percentage':
          return format('0.00%', this.metricValue) || EMPTY;
        case 'number':
          return format('0.00', this.metricValue) || EMPTY;
        case 'string':
          return String(this.metricValue);
        default:
          return String(this.metricValue);
      }
    },
  },
};
</script>
